import type { FC } from 'react'
import styled from '@emotion/styled'
import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const data = {
  title: `As digital soars,<br/>personalization is within reach.`,
  description: `To remain competitive, highly personalized customer experiences, built on a foundation of first-party data, have become the primary means of driving customer loyalty and differentiation, as well as a higher bottom line for businesses.`,
}

const AsDigitalSoars: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <TextWrapper>
          <CopyTextBase centered={true}>
            <CopyText.Heading
              tag="h2"
              variant="h2"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(data.title, { allowedTags: [`br`] }),
              }}
            />
            <CopyText.Description tag="p" variant="pLarge">
              {data.description}
            </CopyText.Description>
          </CopyTextBase>
        </TextWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const TextWrapper = styled.div`
  max-width: 684px;
  margin: 0 auto;
`

export default AsDigitalSoars
